import { defineMessages } from "react-intl";

const messages = defineMessages({
  threshold: {
    id: "riskManagement.utils.threshold",
    defaultMessage: "Risk Alert Threshold Settings",
  },
  auditlog: {
    id: "riskManagement.utils.auditlog",
    defaultMessage: "Audit Log for Risk Threshold",
  },
  reports: {
    id: "riskManagement.utils.reports",
    defaultMessage: "Reports",
  },
});

export default messages;
